import { __assign, __rest } from "tslib";
import React, { useCallback } from 'react';
import InputField from '../InputField';
import s from './LimitedTextInputField.scss';
/** One of our standard `<input type="text" />`s.
 *
 * Limits input to a a specified length (`max`) and displays the remaining character allowance to the right of the inner input.
 */
var LimitedTextInputField = React.forwardRef(function (_a, ref) {
    var maxLength = _a.maxLength, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["maxLength", "value", "onChange"]);
    var handleOnChange = useCallback(function (e) {
        if (e.target.value.length > maxLength) {
            return;
        }
        onChange && onChange(e);
    }, [onChange, maxLength]);
    return (React.createElement(InputField, __assign({ type: "text", maxLength: maxLength, value: value, onChange: handleOnChange, postfix: React.createElement("span", { className: s['postfix'] }, maxLength - value.length) }, rest, { ref: ref })));
});
export default LimitedTextInputField;
//# sourceMappingURL=LimitedTextInputField.js.map